import React, { useState, useEffect } from 'react';

function ScrollOnTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
       setVisible(true);
       console.log('Telah Capai Lebih dari 300');
      } else {
       setVisible(false);
       console.log('Kurang dari 300');
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {visible && (
        <button
          onClick={scrollToTop}
          className="bg-[#BC785B] text-white p-3 rounded-full shadow-lg 
            hover:bg-[#96604A] transition-all duration-300
            hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#BC785B] focus:ring-opacity-50"
          aria-label="Scroll to top"
        >
          {/* Simple up arrow using HTML entities */}
          <svg 
            className="w-6 h-6" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M5 10l7-7m0 0l7 7m-7-7v18" 
            />
          </svg>
        </button>
      )}
    </>
  );
}

export default ScrollOnTopButton;